export function fireNativeInputChangeEvent(el, value) {
  var nativeSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
  nativeSetter.call(el, value);
  var fauxEvent = new Event('input', {
    bubbles: true
  });
  el.dispatchEvent(fauxEvent);
}